export default {
  // 用户交互-自定义CustomReason-content
  permission_change_text: 'Your current role in the organization:', // 权限变更
  join_the_organization_successfully_text:
    'Your application has been approved.', // 人员变动：申请通过
  application_rejection_text:
    'Your application has been rejected, you can initiate another application in the developer portal.', // 人员变动：申请拒绝
  permission_remove_text:
    'You have been removed out of the studio by the owner', // 人员变动：被移出X工作室
  new_join_organization_successfully:
    'You have successfully joined the organization', // 人员变动：新用户被邀请加入
  exits_text: 'You have successfully exited the studio.', // 主动退出 => 退出人

  // 用户交互- 自定义标题CustomSubject
  title_owner_transfer_notification: 'Owner transfer notification', // 权限变更 - Owner权限变更
  title_permission_change_text: 'Permission change', // 权限变更, Admin权限变更,用户组成员变动
  title_group_permission_change: 'Group permission change', // 权限变更 - 用户组权限变动
  title_group_scope_change: 'Group scope change', // 权限变更 - 用户组范围变动通知
  title_permission_studio_delete: 'Studio deletion notification',
  title_permission_game_delete: 'Title deletion notification',
  title_permission_env_delete: 'Environment deletion notification',

  title_application_join_text: 'Application for joining', // 人员变动：申请加入组织
  title_join_the_organization_successfully_text:
    'Join the organization successfully', // 人员变动：申请通过<主动申请的加入>
  title_application_rejection_text: 'Application rejection', // 人员变动：申请被拒绝
  title_permission_remove_text: 'Organization change', // 人员变动：被移出X工作室
  title_new_join_organization_successfully: 'Join the studio successfully', // 人员变动：新用户被邀请加入
  title_exit_org: 'Organization change', // 主动退出工作室
  title_service_open_success: 'Apply the service successfully', // 服务开通成功
  title_service_open_failed: 'Failed to apply the service', // 服务开通失败
  title_company_certified_successfully: 'The authentication is approved',
  title_balance_alert: 'Balance early warning notice',
  title_service_apply_pass: 'Apply the service successfully',
  title_service_apply_pending: 'Service Activation Application',
  title_service_apply_fail: 'Failed to apply the service',
  title_balance: 'Balance Early Warning',
  title_company_certified_failed: 'The authentication is not approved',
  changes_c: '[Changes]',
  fixed_c: '[Fixed]',
  announcement_c: '[Announcement]',
  changes_type: 'Changes',
  fixed_type: 'Fixed',
  announcement_type: 'Announcement',
  notice_type: 'Notice',
  notice_apply_success: '[Notice] Apply the service successfully',
  notice_apply_failed: '[Notice] Failed to apply the service',
  apply_success_message: 'Apply the service successfully',
  apply_failed_message: 'Failed to apply the service',
};
